import { render, staticRenderFns } from "./BookingSummaryCard.vue?vue&type=template&id=5a8f9690&scoped=true&"
import script from "./BookingSummaryCard.vue?vue&type=script&lang=js&"
export * from "./BookingSummaryCard.vue?vue&type=script&lang=js&"
import style0 from "./BookingSummaryCard.vue?vue&type=style&index=0&id=5a8f9690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8f9690",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VAvatar,VCard,VCardText,VCardTitle,VChip,VDivider,VIcon})
